<template>
  <div id="app">
    <ModalContainer />
    <Header v-if="location === 'enskede'" />
    <HeaderHagaNorra v-if="location === 'haga-norra'" />
    <router-view />
    <Footer v-if="hasLocation" />
  </div>
</template>

<script>
  import SliceLoader from 'mixins/slice-loader';
  import ContentLoader from 'mixins/content-loader';
  import Header from 'components/header';
  import HeaderHagaNorra from 'components/header-haga-norra';
  import Footer from 'components/footer';
  import ModalContainer from 'components/modal-container';

  export default {
    name: 'App',
    components: { ModalContainer, Header, HeaderHagaNorra, Footer },
    mixins: [SliceLoader, ContentLoader],
    computed: {
      location () {
        return this.$route.params.location || this.$route?.meta?.location;
      },
      hasLocation () {
        return ['enskede', 'haga-norra'].includes(this.location);
      }
    },
    watch: {
      $route (to) {
        if (to.name === 'index') {
          this.loadContent();
        }

        window.scrollTo(window.scrollX, 0);
        this.setTitle(to);
      }
    },
    mounted () {
      this.titleEl = document.querySelector('title');
      this.defaultTitle = this.titleEl.innerText;
      this.setTitle(this.$route);
    },
    methods: {
      setTitle (route) {
        const title = route.meta && route.meta.title;

        if (route.name === 'index') {
          document.title = this.defaultTitle;
          return;
        }

        document.title = title ? `${title} - ${this.defaultTitle}` : this.defaultTitle;
      }
    }
  };
</script>

<style lang="stylus">
  @require '~global/reset'
  @require '~global/fonts'
  @require '~global/typo'

  html
    @extend .t-base
    -webkit-font-smoothing: antialiased
    -moz-osx-font-smoothing: grayscale

  body
    overflow-x: hidden
    text-underline-offset: 4px

  a
    text-decoration: none

  a:hover
    color: $red
</style>
